import React from "react";

import { LoadingSlideNoText } from "@components/title-slide-view";
import { useNorthbeamQuery } from "@hooks/http";
import {
  type GetCampaign_me_adObject,
  type GetCommonTouchpoints,
  type GetCommonTouchpointsVariables,
} from "@north-beam/nb-client-side";
import { type DateInterval } from "@north-beam/nb-common";
import { GET_COMMON_TOUCHPOINTS } from "@pages/objects/common-touchpoints";

import { JourneyContent } from "./journey-content";

interface Props {
  adObject: GetCampaign_me_adObject;
  dateRange: DateInterval;
}

export const Journey = ({ adObject, dateRange }: Props) => {
  const { data, loading } = useNorthbeamQuery<
    GetCommonTouchpoints,
    GetCommonTouchpointsVariables
  >(GET_COMMON_TOUCHPOINTS, {
    variables: { id: adObject.id, dateRange },
    useHeavy: true,
  });

  if (loading) {
    return (
      <div className="h-96 w-96 my-24 mx-auto">
        <LoadingSlideNoText />
      </div>
    );
  }

  if (!data || !data.me.adObject) {
    return (
      <p className="text-center p-24">
        Could not load this page. Please contact Northbeam support!
      </p>
    );
  }

  return (
    <JourneyContent
      adObject={adObject}
      touchpoints={data.me.adObject.commonTouchpoints}
    />
  );
};
